import { render, staticRenderFns } from "./partnerNotification.vue?vue&type=template&id=02e1ea9c&"
import script from "./partnerNotification.vue?vue&type=script&lang=js&"
export * from "./partnerNotification.vue?vue&type=script&lang=js&"
import style0 from "./partnerNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports